module.exports = __webpack_public_path__ + "static/media/triangle-header-pattern.2a425a39.svg";